import "materialize-css/dist/css/materialize.min.css";
import "material-icons/iconfont/outlined.css";
import "materialize-css/dist/js/materialize.min.js";
import "@/assets/css/style.css";
import "@/assets/css/form.css";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

createApp(App).use(store).use(router).mount("#app");
